export const getShortYear = (year) => {
  return +String(year).slice(2);
}
